/**
 * Shared limits for screen metadata shown in lists, map popups, and cards.
 * Full text belongs on the advertiser screen info page (or admin details).
 */
export const SCREEN_DISPLAY_LIMITS = {
  addressLine: 72,
  locationDescriptionSummary: 120,
  brandTypeLine: 56,
  dimensionsLine: 48,
  popupLocationDescription: 140,
  popupAddress: 100,
  gridMetric: 40,
};

/**
 * @param {unknown} value
 * @param {number} maxLength
 * @returns {string}
 */
export function truncateDisplay(value, maxLength) {
  if (value === undefined || value === null) {
    return '';
  }
  const s = String(value).trim();
  if (s.length <= maxLength) {
    return s;
  }
  return `${s.slice(0, Math.max(0, maxLength - 1))}…`;
}
